import UserProfileCard from "./UserProfileCard";

export default UserProfileCard;
